"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseInput = void 0;
const React = require("react");
const ApiClientContext_1 = require("../../../../contexts/ApiClientContext");
class BaseInput extends React.Component {
    constructor(props) {
        super(props);
        this.firstChange = true;
        this.state = Object.assign(Object.assign({}, this.state), { fetchingSuggestions: false, suggestions: null });
    }
    componentDidMount() {
        if (this.props.suggestion) {
            if (this.context.client === null) {
                console.error("Cannot fetch suggestion as client context is not implemented");
                return;
            }
            this.fetchSuggestionData();
        }
    }
    fetchSuggestionData() {
        this.setState({
            fetchingSuggestion: true
        });
        this.context.client.suggestions
            .getSuggestionData(this.props.suggestion)
            .then(sug => {
            this.setState({
                fetchingSuggestion: false,
                suggestion: sug
            });
        });
    }
    // ready the formatting variables for faster use
    prepare() {
        if (!this.bannedValuesRegex) {
            // allow child-components to provide their own banned values
            this.bannedValuesRegex = this.props.allowableValues
                ? new RegExp(`[^${this.props.allowableValues}]`, "g")
                : null;
        }
        if (!this.preparedFormatters) {
            // allow sub classes to pre-set this
            this.preparedFormatters = (this.props.formatters || []).map((f) => {
                if (f.type === "pattern") {
                    return {
                        type: "pattern",
                        pattern: typeof f.pattern === "string" ? new RegExp(f.pattern) : f.pattern,
                        blueprint: f.blueprint,
                        filter: typeof f.filter === "string"
                            ? new RegExp(f.filter, "g")
                            : f.filter
                    };
                }
                return f;
            });
        }
    }
    onInputChange(newValue) {
        if (this.firstChange) {
            this.prepare();
            this.firstChange = false;
        }
        if (typeof newValue === "string") {
            let newStringValue = newValue;
            // run additional formatters if value is a string
            // removed illegal characters
            if (this.bannedValuesRegex) {
                newStringValue = newStringValue.replace(this.bannedValuesRegex, "");
            }
            // perform formatting
            this.preparedFormatters.map(formatter => {
                switch (formatter.type) {
                    case "pattern":
                        newStringValue = newStringValue.replace(formatter.pattern, formatter.blueprint);
                        newStringValue = formatter.filter
                            ? newStringValue.replace(formatter.filter, "")
                            : newStringValue;
                        break;
                    case "uppercase":
                        newStringValue = newStringValue.toUpperCase();
                        break;
                    case "lowercase":
                        newStringValue = newStringValue.toLowerCase();
                        break;
                }
            });
            newValue = newStringValue;
        }
        // call standard callback by default
        this.props.onInputChange(newValue);
    }
}
exports.BaseInput = BaseInput;
BaseInput.contextType = ApiClientContext_1.ApiClientContext;
//# sourceMappingURL=index.js.map